import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import { CouponInterface } from 'common/types/entities/CouponInterface'
import React from 'react'
import { GroupTitle } from 'src/editor/layout/sidebar/settings/group-title'
import { ColorPickerControl } from 'src/editor/shared/settings/controls/color-picker/color-picker-control'
import { SizeAndPositionGroup } from 'src/editor/shared/settings/groups/size-and-position'
import Input from '../components/Input/Input'
import { useUpdateNestedProp, useUpdateProp } from '../hooks/useUpdateProps'
import DeviceAppearance from '../options/DeviceAppearance/DeviceAppearance'
import HtmlAttrId from '../options/HtmlAttrId'
import { FontSize } from '../styles'
import Border from '../styles/Border'

export default function CouponSettings({
  entity,
}: {
  entity: CouponInterface
}) {
  const { isMobile } = useDeviceModeContext()

  const updateProp = useUpdateProp(entity)
  const updateNestedProp = useUpdateNestedProp(entity)

  return (
    <>
      <GroupTitle isFirst>entity_settings.coupon.field.group_title</GroupTitle>
      <Input
        label={'entity_settings.coupon.field.placeholder'}
        value={entity.field.placeholder}
        update={updateNestedProp('field')('placeholder')}
      />
      <FontSize
        update={updateNestedProp('field')('fontSize')}
        mobileUpdate={updateNestedProp('field')('mobileFontSize')}
        fontSize={entity.field.fontSize}
        mobileFontSize={entity.field.mobileFontSize}
      />
      <ColorPickerControl
        label="entity_settings.coupon.field.text_color"
        update={updateNestedProp('field')('color')}
        mobileUpdate={updateNestedProp('field')('mobileColor')}
        color={entity.field.color}
        mobileColor={entity.field.mobileColor}
      />
      <ColorPickerControl
        label="entity_settings.coupon.field.bg_color"
        update={updateNestedProp('field')('backgroundColor')}
        mobileUpdate={updateNestedProp('field')('mobileBackgroundColor')}
        color={entity.field.backgroundColor}
        mobileColor={entity.field.mobileBackgroundColor}
      />
      <Border
        update={updateNestedProp('field')('border')}
        border={entity.field.border}
        mobileUpdate={updateNestedProp('field')('mobileBorder')}
        mobileBorder={entity.field.mobileBorder}
      />
      <GroupTitle>entity_settings.coupon.button.group_title</GroupTitle>
      <Input
        label="entity_settings.coupon.button.text"
        value={entity.button.text}
        update={updateNestedProp('button')('text')}
      />
      <FontSize
        update={updateNestedProp('button')('fontSize')}
        mobileUpdate={updateNestedProp('button')('mobileFontSize')}
        fontSize={entity.button.fontSize}
        mobileFontSize={entity.button.mobileFontSize}
      />
      <ColorPickerControl
        label="entity_settings.coupon.button.text_color"
        update={updateNestedProp('button')('color')}
        mobileUpdate={updateNestedProp('button')('mobileColor')}
        color={entity.button.color}
        mobileColor={entity.button.mobileColor}
      />
      <ColorPickerControl
        label="entity_settings.coupon.button.bg_color"
        update={updateNestedProp('button')('backgroundColor')}
        mobileUpdate={updateNestedProp('button')('mobileBackgroundColor')}
        color={entity.button.backgroundColor}
        mobileColor={entity.button.mobileBackgroundColor}
      />
      <Border
        update={updateNestedProp('button')('border')}
        border={entity.button.border}
        mobileUpdate={updateNestedProp('button')('mobileBorder')}
        mobileBorder={entity.button.mobileBorder}
      />
      <SizeAndPositionGroup
        margin={isMobile ? entity.mobileMargin : entity.margin}
        updateMargin={updateProp(isMobile ? 'mobileMargin' : 'margin')}
      />
      <DeviceAppearance
        update={updateProp('appearance')}
        desktop={entity.appearance.desktop}
        mobile={entity.appearance.mobile}
      />
      <HtmlAttrId attrId={entity.htmlAttrId} />
    </>
  )
}
